export default {
  filters: {
    priceFormat(price) {
      if (!price) return price;
      return `${price}`.replace(".", ",");
    },
  },
};
